<template>
  <div class="container-resumo-pacientes">
    <div class="header-resumo-pacientes">
      <span>Pacientes cadastrados</span>
    </div>
    <div v-if="resumo">
      <apexchart
          v-if="resumo.quantidadeCadastros > 0"
          type="donut"
          height="300"
          :options="chartOptions"
          :series="series"
      />
    </div>
  </div>
</template>

<script>

export default {
    name: 'ResumoPacientesCadastrados',
    props: {
        resumo: Object
    },
    computed: {
        series() {
            return [
                this.resumo.quantidadeSexoMasculino,
                this.resumo.quantidadeSexoFeminino
            ]
        },
        chartOptions() {
            return {
                labels: ['Masculino', 'Feminino'],
                legend: {
                    position: 'bottom'
                },
                plotOptions: {
                    pie: {
                        donut: {
                            size: '65%',
                            labels: {
                                show: true,
                                total: {
                                    show: true,
                                    label: 'Total',
                                    fontSize: '14px',
                                    fontWeight: 600,
                                    formatter: () => this.resumo.quantidadeCadastros
                                }
                            }
                        }
                    }
                },
                tooltip: {
                    y: {
                        formatter: (value) => `${value} pacientes`
                    }
                }
            }
        }
    }
}
</script>


<style scoped lang="stylus">

.container-resumo-pacientes
  box-shadow rgba(0, 0, 0, 0.2) 0px 12px 28px 0px, rgba(0, 0, 0, 0.1) 0px 2px 4px 0px, rgba(255, 255, 255, 0.05) 0px 0px 0px 1px inset
  border-radius 5px
  height 350px

.header-resumo-pacientes
  padding-left 5px
  height 41.59px
  display flex
  align-items center
  border-bottom 1px solid #ddd
  font-weight bold
  color var(--theme-primary)

</style>